import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import config from './config';
import { map } from 'rxjs/operators';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { ActivateComponentService } from './activate-component.service';
@Injectable()
export class LearnerHelperService {

    private learnerDataCache = {
        spaces: null,
        entitlements: null
    }

    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private activateComponentService: ActivateComponentService,
    ) {
    }

    public getLearnerSpacesAndEntitlementsDataFromAPI(dataNeeded = { spaces: true, classes: true, entitlements: true }): Observable<any> {
        let options = { };
        return this.http.post(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'getLearnerSpacesAndEntitlementsData', { dataNeeded, options }).pipe(map((res: any) => {
            if (res.status == "error" && res.error == "INVALID_USER_ROLE") {
                // logout user if some non-teacher tried to access teacher data
                return;
            }
            if (res.entitlements) {
                this.learnerDataCache.entitlements = res.entitlements;
                
                let entitlementsClone = JSON.parse(JSON.stringify(this.learnerDataCache.entitlements));
                // setting activated products
                this.modifyEntitlementsAndActivateProducts(entitlementsClone);
            }
            if (res.userSpaces) {
                this.learnerDataCache.spaces = res.userSpaces;
            }
            return this.learnerDataCache;
        }));
    }

    public getLearnerSpacesAndClassData(): Observable<any> {
        if (this.learnerDataCache.spaces && this.learnerDataCache.spaces.entities) {
            return of(this.learnerDataCache);
        }
        else {
            return this.getLearnerSpacesAndEntitlementsDataFromAPI({ spaces: true, classes: true, entitlements: false });
        }
    }

    public getLearnerEntitlementsData(): Observable<any> {
        if (this.learnerDataCache.entitlements && this.learnerDataCache.entitlements.length) {
            return of(this.learnerDataCache);
        }
        else {
            return this.getLearnerSpacesAndEntitlementsDataFromAPI({ spaces: false, classes: false, entitlements: true });
        }
    }

    modifyEntitlementsAndActivateProducts(entitlements) {
        const activatedProducts = [];
        const expiredEntitlements = [];
        const entitlementToExpireDate = {};
        if (entitlements && entitlements.length) {
            entitlements.forEach((product) => {
                activatedProducts.push(product.productcode);
                entitlementToExpireDate[product.productcode] =  product.entitlement.end_date;
                if(Date.now() > product.entitlement.end_date) {
                    expiredEntitlements.push(product.productcode)
                }
            });
        }
        this.activateComponentService.setEntitlementsForUser(activatedProducts);
        this.activateComponentService.setExpiredEntitlementsForUser(expiredEntitlements, entitlementToExpireDate);
    }


}